module.exports = __webpack_public_path__ + "static/office2-9dd846aeb21ca910d6cd526d8138b9ea.png";